"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _toConsumableArray2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "code:view",
  mixins: [_CustomTableColumn.default],
  permission: "dictionaryManagement",
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  data: function data() {
    return {
      query: [],
      searchSelected: "Name",
      viewOnly: false,
      paginationOptions: {
        page: 1,
        limit: 10
      },
      showDialog: false,
      allDepartments: [],
      allSortCode: [],
      roles: [],
      tableData: [],
      totalData: 0,
      search: "",
      formData: {
        sortCode: []
      },
      formTitle: "",
      formButton: "",
      rules: {
        name: [{
          required: true,
          message: this.$t("system.code.dictionaryName") + this.$t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: this.$t("system.code.code") + this.$t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        sortCode: [{
          required: true,
          message: this.$t("system.code.dictionaryCategory") + this.$t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      },
      toBeDelete: null,
      googleDialog: false,
      loading: true,
      refreshLoading: false,
      searchQuery: {
        sortCode: '',
        code: '',
        parentCode: ''
      }
    };
  },
  created: function created() {
    this.fetchData();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['searchOptionsInDictionaryManagement']), {
    paramShow: function paramShow() {
      var _this2 = this;

      var res = "";
      this.searchOptionsInDictionaryManagement.forEach(function (opt) {
        if (opt.value === _this2.searchSelected) {
          res = opt.label;
          return;
        }
      });
      return res;
    },
    disableQuery: function disableQuery() {
      var _this3 = this;

      var res = this.query.filter(function (q) {
        return q.key == _this3.paramShow;
      });
      if (res.length) return true;
      return false;
    }
  }),
  methods: {
    fetchData: function fetchData() {
      var _this4 = this;

      var _this = this;

      _this.loading = true;

      _httpUtils.default.post("code", "list", null, {
        pageNum: _this.paginationOptions.page,
        pageSize: _this.paginationOptions.limit,
        sortCode: _this.searchQuery.sortCode,
        code: _this.searchQuery.code,
        parentCode: _this.searchQuery.parentCode
      }).then(function (res) {
        if (res.code === 200) {
          _this.tableData = res.data.rows;
          _this.totalData = res.data.total;
        } else {
          _this.$notify({
            title: _this4.$t("common.error"),
            message: _this4.$t("common.fetchError"),
            type: "error"
          });
        }

        _this.loading = false;
      }).catch(function (err) {
        _this.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });

        _this.loading = false;
      });

      _httpUtils.default.post("codeSort", "getAllCodeSorts", null, null).then(function (res) {
        if (res.code === 200) {
          _this.allSortCode = res.data;
        }
      }).catch(function (err) {
        _this4.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    addData: function addData(data) {
      var _this5 = this;

      var _this = this;

      _httpUtils.default.post("code", "add", null, data).then(function (res) {
        if (res.code === 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.codeAdd.codeAddFormSuccessText"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this5.$notify({
          title: _this5.$t("common.error"),
          message: _this5.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    updateData: function updateData(data) {
      var _this6 = this;

      var _this = this;

      _httpUtils.default.post("code", "update", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.closeDialog();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.codeUpdate.codeUpdateFormSuccessText"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this6.$notify({
          title: _this6.$t("common.error"),
          message: _this6.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    deleteData: function deleteData(data) {
      var _this7 = this;

      var _this = this;

      _httpUtils.default.post("code", "delete", null, data).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this.$t("common.success"),
            message: _this.$t("system.code.deleteCodeSuccess"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this.$t("common.error"),
            message: res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this7.$notify({
          title: _this7.$t("common.error"),
          message: _this7.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    handleSearch: function handleSearch() {
      this.paginationOptions.page = 1;
      this.paginationOptions.limit = 10;
      this.fetchData();
    },
    refreshData: function refreshData() {
      var _this8 = this;

      var _this = this;

      _this.refreshLoading = true;

      _httpUtils.default.post("code", "loadReapplication", null, null).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this8.$t('common.success'),
            message: _this8.$t("system.code.cacheRefreshed"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this8.$t('common.error'),
            message: _this8.$t('common.error') + res.message,
            type: "error"
          });
        }

        _this.refreshLoading = false;
      }).catch(function (err) {
        _this8.$notify({
          title: _this8.$t("common.error"),
          message: _this8.$t("SMS.error") + ',' + err.message,
          type: "error"
        });

        _this.refreshLoading = false;
      });
    },
    refreshMerchantData: function refreshMerchantData() {
      var _this9 = this;

      var _this = this;

      _httpUtils.default.post("code", "loadMerchantApplication", null, null).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this9.$t('common.success'),
            message: _this9.$t("system.code.merchantCacheRefreshed"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this9.$t('common.error'),
            message: _this9.$t('common.error') + res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this9.$notify({
          title: _this9.$t("common.error"),
          message: _this9.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    refreshMerchantSendData: function refreshMerchantSendData() {
      var _this10 = this;

      var _this = this;

      _httpUtils.default.post("code", "loadMerchantSendApplication", null, null).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this10.$t('common.success'),
            message: _this10.$t("system.code.merchantCacheRefreshed"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this10.$t('common.error'),
            message: _this10.$t('common.error') + res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this10.$notify({
          title: _this10.$t("common.error"),
          message: _this10.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    refreshAgentData: function refreshAgentData() {
      var _this11 = this;

      var _this = this;

      _httpUtils.default.post("code", "loadAgentApplication", null, null).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this11.$t('common.success'),
            message: _this11.$t("system.code.agentCacheRefreshed"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this11.$t('common.error'),
            message: _this11.$t('common.error') + res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this11.$notify({
          title: _this11.$t("common.error"),
          message: _this11.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    refreshGatewayData: function refreshGatewayData() {
      var _this12 = this;

      var _this = this;

      _httpUtils.default.post("code", "loadGatewayApplication", null, null).then(function (res) {
        if (res.code == 200) {
          _this.fetchData();

          _this.$notify({
            title: _this12.$t('common.success'),
            message: _this12.$t("system.code.gatewayCacheRefreshed"),
            type: "success"
          });
        } else {
          _this.$notify({
            title: _this12.$t('common.error'),
            message: _this12.$t('common.error') + res.message,
            type: "error"
          });
        }
      }).catch(function (err) {
        _this12.$notify({
          title: _this12.$t("common.error"),
          message: _this12.$t("SMS.error") + ',' + err.message,
          type: "error"
        });
      });
    },
    transformSortCode: function transformSortCode(param) {
      var result = param;
      this.allSortCode.forEach(function (sortCode) {
        if (sortCode.code === param) return result = sortCode.name;
      });
      return result;
    },
    handleDialog: function handleDialog(cmd, id) {
      var _this13 = this;

      this.initForm(cmd);

      if (cmd == "view") {
        this.viewOnly = true;
        this.fillForm(id);
      }

      if (cmd == "edit") this.fillForm(id);
      this.$nextTick(function () {
        return _this13.showDialog = true;
      });
    },
    handlePagination: function handlePagination(newOptions) {
      var _this14 = this;

      this.paginationOptions = newOptions;
      this.$nextTick(function () {
        return _this14.fetchData();
      });
    },
    handleSubmit: function handleSubmit() {
      var _this15 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var dummy = (0, _objectSpread2.default)({}, _this15.formData);
          var sortCode = "";
          var sortCodeArray = (0, _toConsumableArray2.default)(dummy.sortCode);
          dummy.sortCode = sortCodeArray.join(",");

          _this15.$nextTick(function () {
            if (dummy.id) {
              _this15.updateData(dummy);
            } else {
              _this15.addData(dummy);
            }
          });
        }
      });
    },
    handleDelete: function handleDelete(codeSortIds) {
      var _this16 = this;

      this.$confirm(this.$t("system.code.toolBarDeleteConfirmInformation"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this16.deleteData([codeSortIds]);
      }).catch(function () {
        return null;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.toBeDelete = val;
    },
    handleMultipleDelete: function handleMultipleDelete() {
      var _this17 = this;

      var temp = this.toBeDelete;

      if (!temp) {
        this.$notify({
          title: this.$t("common.error"),
          message: this.$t("system.code.toolBarDeleteWarnText"),
          type: "error"
        });
        return;
      }

      var codeSortIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = temp[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var data = _step.value;
          codeSortIds.push(data.id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$confirm(this.$t("system.code.toolBarDeleteConfirmInformation"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.delete"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(function () {
        return _this17.deleteData(codeSortIds);
      }).catch(function () {
        return null;
      });
    },
    initForm: function initForm(cmd) {
      if (cmd == "add") {
        this.formTitle = this.$t("system.code.toolBarAddOpenText");
        this.formButton = this.$t("common.add");
      } else if (cmd == "edit") {
        this.formTitle = this.$t("system.code.codeTableEditOpenText");
        this.formButton = this.$t("common.edit");
      }

      this.viewOnly = false;
    },
    fillForm: function fillForm(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.tableData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var data = _step2.value;

          if (data.id == id) {
            var sortCode = [];
            var code = data.sortCode.split(",");
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = code[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var i = _step3.value;
                sortCode.push(i);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            this.formData = {
              id: data.id,
              sortCode: sortCode,
              code: data.code,
              name: data.name,
              parentCode: data.parentCode,
              description: data.description,
              remark: data.remark
            };
            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    closeDialog: function closeDialog() {
      var _this18 = this;

      this.showDialog = false;
      this.formData = {
        sortCode: []
      };
      this.$nextTick(function () {
        return _this18.$refs["dataForm"].clearValidate();
      });
    },
    dateFormat: function dateFormat(date) {
      if (date === undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
exports.default = _default;